import logo1 from "../../assets/images/brick_icons/brick_logo_f.png";
import "./AfterLoginheader.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "@fontsource/plus-jakarta-sans";
import { updateLoginStatus } from "../../store/userDetails";
import { useState, useEffect } from "react";
import { baseurl } from "../BaseUrl/Baseurl";
import axios from "axios";
import profile from "../../assets/images/profile.png";
import { Container, Nav, Navbar } from "react-bootstrap";
import { LuLogOut } from "react-icons/lu";
import { PiTreeStructureLight } from "react-icons/pi";
import { deleteDB } from "idb";

const DB_NAME = "create-project-db";

async function deleteEntireDatabase() {
  try {
    // Calling deleteDB() will close any open connections and delete the database.
    await deleteDB(DB_NAME);
    console.log(`Database '${DB_NAME}' deleted successfully.`);
  } catch (error) {
    console.error(`Error deleting database '${DB_NAME}':`, error);
  }
}

export default function Header() {
  const userData = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Global Data
    if (userData.Pagename == undefined) {
      dispatch(
        updateLoginStatus({
          isLoggedIn: true,
          Pagename: "Admin_Console",
          userName: userData.userName,
          userId: userData.userId,
          role: userData.role,
          token: userData.token,
          projectId: userData.projectId,
          clientId: userData.clientId,
          projectType: userData.projectType,
          profileImage: userData.profileImage,
        }),
      );
    }
  }, [userData.Pagename]);

  function updatelinkname(lname) {
    // Page name update
    dispatch(
      updateLoginStatus({
        isLoggedIn: true,
        Pagename: lname,
        userName: userData.userName,
        userId: userData.userId,
        role: userData.role,
        token: userData.token,
        projectId: userData.projectId,
        clientId: userData.clientId,
        profileImage: userData.profileImage,
        projectType: userData.projectType,
      }),
    );
    setIsExpanded(false);
  }

  async function logoutfunc() {
    // Logout
    axios({
      method: "PUT",
      url: baseurl + "/api/logout?userId=" + userData.userId,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userData.token,
      },
    })
      .then((response) => {})
      .catch((error) => {
        console.error(error);
      });
    sessionStorage.clear();
    await deleteEntireDatabase();

    window.location.href = "/";
  }

  const [isExpanded, setIsExpanded] = useState(false);
  const data = JSON.parse(sessionStorage.getItem("reduxState"));
  const role = data?.role;

  return (
    <div className="headersizediv gradient-bg">
      <Navbar
        collapseOnSelect
        expand="xl"
        variant="dark"
        className="gradient-bg custom-header-nav py-1 px-3"
        onToggle={(expanded) => setIsExpanded(expanded)}
        expanded={isExpanded}
      >
        <Container fluid className="mx-0 px-0 d-flex align-items-center justify-content-between">
          <Navbar.Brand className="m-0 p-0 d-flex align-items-center">
            <img
              src={logo1}
              alt="logo"
              className="headlogo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" className="p-1 border-0" />

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-between align-items-center"
          >
            <Nav className="align-items-center ml-xl-4 flex-grow-1">
              <ul className="d-flex align-items-center mb-0 p-0 nav-tab-list">
                {role !== "AE" && (
                  <li className="nav-tab-item">
                    <Nav.Link
                      as={Link}
                      to="/AdminConsole"
                      onClick={() => updatelinkname("Admin_Console")}
                      className={`nav-tab-link Linkeffect d-inline-flex align-items-center ${
                        userData.Pagename === "Admin_Console"
                          ? "nav-tab-active"
                          : "nav-tab-inactive"
                      }`}
                    >
                      <PiTreeStructureLight
                        size={20}
                        className="mr-1.5 nav-tab-icon"
                      />
                      <span className="nav-tab-text">
                        Admin Console
                      </span>
                    </Nav.Link>
                  </li>
                )}
              </ul>
            </Nav>

            <div className="d-flex align-items-center justify-content-end header-user-actions">
              <div className="d-flex align-items-center user-profile-box">
                <img
                  src={userData.profileImage || profile}
                  alt="profile"
                  className="profimg"
                />
                <div className="d-flex flex-column ml-2 user-info-col">
                  <span className="user-name-text namefont">
                    <b>{userData.userName}</b>
                  </span>
                  {userData.role && (
                    <span className="user-role-text">
                      {userData.role}
                    </span>
                  )}
                </div>
              </div>

              <div className="ml-3 d-flex align-items-center">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    void logoutfunc();
                  }}
                  className="logout-link"
                  title="Logout"
                  aria-label="logout"
                >
                  <LuLogOut size={16} />
                </Link>
              </div>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
